// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"89343955","446":"5309ddb1","583":"42e84ef2","944":"bfcc8657"}[chunkId] + ".chunk.js";
};